export default "__VITE_ASSET__431c20f3__"